import styled from 'styled-components'
import { MegaButton } from '../../common'

export const ActionButton = styled(MegaButton)`
  margin: 0 0 0 auto;
  padding: 0 5px;
  display: block;
  height: 30px;
  font-size: 12px;
`
